var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3039 115.764V106.701H36.9914V60.4828C36.9914 52.0244 39.4836 44.4975 44.468 37.902C49.4523 31.3065 56.0226 27.1529 64.1789 25.4411V21.0609C64.1789 18.7449 65.0096 16.8317 66.6711 15.3213C68.3325 13.8109 70.3213 13.0557 72.6372 13.0557C74.9532 13.0557 76.9419 13.8109 78.6034 15.3213C80.2648 16.8317 81.0956 18.7449 81.0956 21.0609V25.4411C89.2518 27.1529 95.8473 31.3065 100.882 37.902C105.917 44.4975 108.434 52.0244 108.434 60.4828V106.701H120.971V115.764H24.3039ZM72.6372 133.889C69.415 133.889 66.5956 132.706 64.1789 130.34C61.7622 127.973 60.5539 125.129 60.5539 121.806H84.7206C84.7206 125.129 83.5374 127.973 81.1711 130.34C78.8048 132.706 75.9601 133.889 72.6372 133.889ZM46.0539 106.701H99.3716V60.4828C99.3716 53.0314 96.8039 46.6876 91.6685 41.4515C86.5331 36.2154 80.2397 33.5973 72.7883 33.5973C65.3369 33.5973 59.0183 36.2154 53.8325 41.4515C48.6468 46.6876 46.0539 53.0314 46.0539 60.4828V106.701Z",
    fill: "#1573FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5801 16.0361L128.295 133.751",
    stroke: "#fff",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotification);
export default __webpack_public_path__ + "static/media/no-notification.2ae9f5e1fcc6ab6bc98147e92768954a.svg";
export { ForwardRef as ReactComponent };